import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColumnApi, DomLayoutType, FilterChangedEvent, GridApi, GridOptions, GridReadyEvent, ITooltipParams, SortChangedEvent } from 'ag-grid-community';
import { AppStatesGridHeaderNames, AppStatesTexts, DateFormat, PaginationPageSizes, PartnerListGridHeaderNames, StorageKeyNamesCommon, StorageKeyNamesManage } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';
import * as moment from 'moment';
import { AppNameFilterComponent } from '../../custom-filters/app-states/app-name-filter/app-name-filter.component';
import { StatesFilterComponent } from '../../custom-filters/app-states/states-filter/states-filter.component';
import { PartnerNameFilterComponent } from '../../custom-filters/app-states/partner-name-filter/partner-name-filter.component';
import { DomainNameFilterComponent } from '../../custom-filters/app-states/domain-name-filter/domain-name-filter.component';

@Component({
  selector: 'app-app-states-static',
  templateUrl: './app-states-static.component.html',
  styleUrls: ['./app-states-static.component.scss']
})
export class AppStatesStaticComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() isStoreParams: boolean;

  @Input() formSide: string;

  @Input() fromComponent: string;

  @Input() sectionName: string;

  idString = '';

  // @Input() fromComponentUniqueName: string;

  gridApi: GridApi;

  gridColumnApi: ColumnApi;

  public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  gridOptions: GridOptions;

  rowSelection: "single" | "multiple" = "single";

  selectedRows: any;

  public columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    sortable: true,
    cellDataType: false,
    filter: true,
    minWidth: 100
  };

  public paginationPageSize = 10;

  public domLayout: DomLayoutType;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  style: any = {
    width: '100%',
    height: '100%'
  };

  col_api_endpoint: boolean;

  col_portal_url: boolean;

  paginationPageSizes = PaginationPageSizes;

  storedParams: any = {
    filterModel: {},
    sortModel: [],
    searchText: ''
  }

  constructor(private storageService: StorageService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'appStatesGrid');
    this.columnDefs = [
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.partnerName,
        field: 'partner_name',
        filter: 'partnerNameFilterComponent',
        comparator: this.sharedService.textComparator,
        hide: true
      },
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.appName,
        field: 'app_name',
        filter: 'appNameFilterComponent',
        comparator: this.sharedService.textComparator,
        hide: true
      },
      {
        flex: 1,
        minWidth: 200,
        headerName: AppStatesGridHeaderNames.state,
        field: 'enable_state',
        filter: 'statesFilterComponent',
        comparator: this.sharedService.textComparator,
        headerClass: 'header-label-center',
        cellRenderer: (params: any) => {
          let a = document.createElement('div');
          a.className = 'text-center fixed-badge';
          let b = document.createElement('span');
          let state = params.data.enable_state;
          b.className = 'badge';
          if (state === AppStatesTexts.requested) {
            b.classList.add('btn-custom-info');
          } else if (state === AppStatesTexts.processing) {
            b.classList.add('btn-custom-success');
          } else if (state === AppStatesTexts.readytoPublish) {
            b.classList.add('btn-custom-warning');
          } else if (state === AppStatesTexts.available) {
            b.classList.add('btn-custom-pri');
          } else if (state === AppStatesTexts.readytoActivate || state === AppStatesTexts.preEnabled) {
            b.classList.add('btn-custom-warning');
          } else if (state === AppStatesTexts.enabled) {
            b.classList.add('btn-custom-store-pri');
          } else if (state === AppStatesTexts.revoked) {
            b.classList.add('btn-custom-danger');
          } else {

          }

          b.innerHTML = (state === AppStatesTexts.readytoPublish) ? AppStatesTexts.readytoPublishText : (state === AppStatesTexts.readytoActivate) ? AppStatesTexts.readytoActivateText :
            (state === AppStatesTexts.preEnabled) ? AppStatesTexts.preEnabledText : state;
          a.appendChild(b);
          return a;
        },
        hide: true,
        sortable: false
      },
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.domainName,
        field: 'customer_name',
        filter: 'domainNameFilterComponent',
        comparator: this.sharedService.textComparator,
        hide: true
      },
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.tierName,
        field: 'tier_name',
        filter: false,
        comparator: this.sharedService.textComparator,
        hide: true
      },
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.workflow,
        filter: false,
        field: 'approval_flow_enabled',
        headerClass: 'header-label-center',
        cellRenderer: (params: any) => {
          let divOuter = document.createElement('div');
          divOuter.classList.add('text-center');
          let fontElem = document.createElement('i');
          fontElem.classList.add('fa-solid', 'fa-fw');
          if (params.data && params.data.approval_flow_enabled) {
            fontElem.classList.add('fa-circle-check', 'text-custom-success');
          } else {
            fontElem.classList.add('fa-circle-xmark', 'text-custom-danger');
          }
          divOuter.appendChild(fontElem);
          return divOuter;
        },
        hide: true
      },
      {
        flex: 1,
        headerName: AppStatesGridHeaderNames.updatedOn,
        field: 'updated_datetime_utc',
        valueGetter: params => {
          // return moment(params.data.updated_datetime_utc).local().format('YYYY-MM-DD HH:mm');
          return moment.utc(params.data.updated_datetime_utc).local().format(DateFormat.formatA);
        },
        comparator: this.sharedService.dateComparator,
        hide: true,
        filter: false,
        minWidth: 200
      }
    ];
    this.gridOptions = {
      sortingOrder: ['asc', 'desc'],
      pagination: true,
      suppressPaginationPanel: false,
      paginationPageSize: this.paginationPageSize,
      animateRows: true,
      context: { componentParent: this },
      onGridReady: ($event: any) => {
        this.onGridReady($event);
      },
      onFilterChanged: (e: FilterChangedEvent) => {
        this.storedParams.filterModel = e.api.getFilterModel();
        this.saveGridParams();
      },
      onSortChanged: (e: SortChangedEvent) => {
        this.storedParams.sortModel = e.columnApi.getColumnState();
        this.gridColumnApi.applyColumnState({
          state: this.storedParams.sortModel
        });
        this.saveGridParams();
      },
    }
    this.frameworkComponents = {
      appNameFilterComponent: AppNameFilterComponent,
      statesFilterComponent: StatesFilterComponent,
      partnerNameFilterComponent: PartnerNameFilterComponent,
      domainNameFilterComponent: DomainNameFilterComponent
    }
    this.operateTableConfigs();
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;

              if (item.sort) {
                column.sort = item.sort;
              }
            }
          });
        });
    }
  }

  checkStoredParams(storedParams: any) {
    this.gridApi.setFilterModel(storedParams.filterModel);
    this.gridApi.onFilterChanged();
    if (storedParams.sortModel.length) {
      this.gridColumnApi.applyColumnState({
        state: storedParams.sortModel
      });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.hideOverlay();
    const storedParams = this.storageService.getGridParams(this.formSide, this.fromComponent, StorageKeyNamesCommon.appStatesStatic);

    const filterModelLength = (storedParams && storedParams.filterModel) ? Object.keys(storedParams.filterModel).length : 0;
    const sortModelLength = (storedParams && storedParams.sortModel) ? (storedParams.sortModel).length : 0;
    if (storedParams && (filterModelLength || sortModelLength)) {
      this.checkStoredParams(storedParams);
    }
    window.setTimeout(() => {
      params.api.sizeColumnsToFit();
    }, 1000);

  }

  saveGridParams() {
    if (this.isStoreParams) {
      this.storageService.saveGridParams(this.storedParams, this.formSide, this.fromComponent, StorageKeyNamesCommon.appStatesStatic);
    }
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    this.rowEditedEvent.emit(event.data);
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.tableConfigOptions.searchText)
    } else if (!this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }
  }

}

